<div appVisibility class="background" [style.background-color]="item.customField30"  [style.backgroundImage]="'url(' + serverPath1+item.customField15 + ')'">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <div>
            <calsoft-editor-text style="margin: 0px;" [data]="data" fxFlex="100"
            [style.font-size]="item.customField31" [ngStyle.lt-md]="{ 'font-size': item.customField32 }" [text]="item?.title">
            </calsoft-editor-text>
        </div>
        <div>
            <h2>{{item.customField20}}</h2>
            <h2>{{item.customField21}}</h2>
        </div>
        <p>
            {{item.customField22}}
        </p>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="container" style="position:sticky;">
        <div fxLayout="row" fxLayout.lt-md="column" class="card sticky-row" [style.height]="item.customField17"
            [style.background-color]="item.customField29" contentAnim [aniName]="item.customField36"
            *ngFor="let img of images">

            <div fxFlex="20" class="image-section">
                <img [src]="serverPath1 + img.customField13" alt="">
            </div>


            <div fxFlex="80" class="text-section" contentAnim [aniName]="item.customField36">
                <h2 class="headline">
                    <calsoft-editor-text style="margin: 0px;" [data]="data" fxFlex="100"
                    [style.font-size]="item.customField33" [ngStyle.lt-md]="{ 'font-size': item.customField34 }" [text]="img.customField10">
                    </calsoft-editor-text>
                </h2>
                <p class="description"><calsoft-editor-text style="margin: 0px;" [data]="data" fxFlex="100"
                    [style.font-size]="item.customField37" [ngStyle.lt-md]="{ 'font-size': item.customField38 }" [text]="img.customField11">
                    </calsoft-editor-text>
                </p>
            </div>
        </div>
    </div>
</div>